import { useRef, useState, useEffect } from 'react'

class AudioPlayers {
  constructor() {
    this.instances = {}
  }

  getInstanceForId(id) {
    if (this.instances[id] === undefined) {
      this.instances[id] = new window.Audio()
    }

    return this.instances[id]
  }

  destroyInstanceForId(id) {
    if (this.instances[id] !== undefined) {
      delete this.instances[id]
    }
  }
}

const audioPlayers = new AudioPlayers()

export default ({
  src,
  startTime,
  endTime,
  onTimeUpdate,
  onEnded = () => {},
  preload = true,
}) => {
  const player = useRef()
  const currentTimeListener = useRef()
  const [isPlaying, setIsPlaying] = useState(false)
  const [loading, setLoading] = useState(false)
  const [currentTime, setCurrentTime] = useState(false)
  const [duration, setDuration] = useState(0)

  useEffect(() => {
    if (!src) {
      player.current = new window.Audio()
    } else {
      player.current = audioPlayers.getInstanceForId(src)
    }

    player.current.src = src
    player.current.preload = preload
    player.current.oncanplay = () => {
      setDuration(player.current.duration)
      setLoading(false)
    }
    player.current.currentTime = startTime || 0.0
    player.current.onended = (event) => {
      setIsPlaying(false)
      onEnded(event)
    }

    if (preload && player.current.src) {
      setLoading(true)
      player.current.load()
    }

    return () => {
      if (currentTimeListener.current) {
        clearInterval(currentTimeListener.current)
      }

      player.current = null

      if (src) {
        audioPlayers.destroyInstanceForId(src)
      }
    }
  }, [])


  const play = (playPause) => {
    if (playPause) {
      player.current.play()

      setIsPlaying(true)


      currentTimeListener.current = setInterval(() => {
        if (endTime && endTime > 0.0 && player.current.currentTime >= endTime && onEnded) {
          player.current.pause()
          player.current.currentTime = startTime
          setIsPlaying(false)
        } else if (player.current) {
          setCurrentTime(player.current.currentTime)
        }
      }, 250)

    } else if (!player.current.paused) {
      setIsPlaying(false)
      player.current.pause()
    }
  }

  const seek = (nextCurrentTime) => {
    if (player.current) {
      player.current.currentTime = nextCurrentTime
    }
  }

  const load = (src) => {
    setLoading(true)
    player.current.src = src
    player.current.load()
  }

  return {
    play,
    isPlaying,
    load,
    loading,
    currentTime,
    seek,
    duration,
  }
}
